// extracted by mini-css-extract-plugin
export var fadeIn = "_8c-0";
export var panelInner = "_8c-2";
export var panelOuter = "_8c-1";